"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _draftJs = require("draft-js");

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _immutable = require("immutable");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _createGetVisibleSelectionRectAtTrigger = _interopRequireDefault(require("../../utils/createGetVisibleSelectionRectAtTrigger"));

var _makeTypingTriggerRegex = _interopRequireDefault(require("../../utils/makeTypingTriggerRegex"));

var _getCurrentTriggerSearchFromEditorState = _interopRequireDefault(require("../../utils/getCurrentTriggerSearchFromEditorState"));

var _getOverlayAnchorPosition = _interopRequireDefault(require("../../utils/getOverlayAnchorPosition"));

var _OverlayResultsContainer = _interopRequireDefault(require("./OverlayResultsContainer"));

var LoadingSizer = _styledComponents.default.div.withConfig({
  displayName: "Overlay__LoadingSizer",
  componentId: "jimij1-0"
})(["align-items:center;display:flex;height:100px;justify-content:center;width:360px;"]);

var MemoizedOverlayResultsContainer = (0, _memoize.default)(_OverlayResultsContainer.default);

var Overlay = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Overlay, _Component);

  function Overlay(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Overlay);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Overlay).call(this, props));
    _this.state = {
      // Keeps the overlay onscreen when editor is out of focus
      forceOverlayFocus: false,
      // Force closes the overlay if a user doesn't want to use the shortcut
      forceCloseSelection: false
    };

    _this.getCurrentSearch = function () {
      var _this$props = _this.props,
          editorState = _this$props.editorState,
          trigger = _this$props.trigger;
      var selection = editorState.getSelection();
      var _this$state = _this.state,
          forceCloseSelection = _this$state.forceCloseSelection,
          forceOverlayFocus = _this$state.forceOverlayFocus;

      if (forceCloseSelection && forceCloseSelection === selection) {
        return null;
      }

      if (!selection.getHasFocus() && !forceOverlayFocus) {
        return null;
      }

      return (0, _getCurrentTriggerSearchFromEditorState.default)(editorState, _this.triggerRegex, trigger);
    };

    _this.handleToggleForcedOverlayFocus = function (isFocused) {
      _this.setState({
        forceOverlayFocus: isFocused
      });
    };

    _this.cancel = function (_ref) {
      var offset = _ref.offset,
          length = _ref.length;
      var _this$props2 = _this.props,
          editorState = _this$props2.editorState,
          onChange = _this$props2.onChange;
      var blockKey = editorState.getSelection().getStartKey();

      var targetRange = _draftJs.SelectionState.createEmpty(blockKey).merge({
        anchorOffset: offset + length,
        focusOffset: offset + length,
        isBackward: false,
        hasFocus: true
      });

      var contentState = _draftJs.Modifier.insertText(editorState.getCurrentContent(), targetRange, '  ');

      onChange(_draftJs.EditorState.push(editorState, contentState, 'insert-characters'));
    };

    _this.forceClose = function () {
      _this.setState({
        forceCloseSelection: _this.props.editorState.getSelection()
      });
    };

    _this.saveCoordinates = function (boundingRect) {
      _this.savedCoordinates = boundingRect;
    };

    var maximumSearch = props.maximumSearch,
        requireNonEmptySearchTerm = props.requireNonEmptySearchTerm,
        ResultsComponent = props.ResultsComponent,
        _trigger = props.trigger;
    _this.triggerRegex = (0, _makeTypingTriggerRegex.default)({
      trigger: _trigger,
      maximumSearch: maximumSearch,
      matchOnlyTrigger: !requireNonEmptySearchTerm
    });
    _this.getVisibleSelectionRectAtTrigger = (0, _createGetVisibleSelectionRectAtTrigger.default)({
      maximumSearch: maximumSearch,
      trigger: _trigger
    });
    _this.ResultsContainer = MemoizedOverlayResultsContainer(ResultsComponent);
    return _this;
  }

  (0, _createClass2.default)(Overlay, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      // Save coordinates for the dropdown so that we can use this if there is
      // no current window selection (eg. when we want to forceOverlay but editor isn't focused)
      this.savedCoordinates = {};
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          maximumSearch = _this$props3.maximumSearch,
          requireNonEmptySearchTerm = _this$props3.requireNonEmptySearchTerm,
          ResultsComponent = _this$props3.ResultsComponent,
          trigger = _this$props3.trigger;

      if (prevProps.ResultsComponent !== ResultsComponent) {
        this.ResultsContainer = MemoizedOverlayResultsContainer(ResultsComponent);
      }

      if (prevProps.maximumSearch !== maximumSearch || prevProps.trigger !== trigger) {
        this.getVisibleSelectionRectAtTrigger = (0, _createGetVisibleSelectionRectAtTrigger.default)({
          maximumSearch: maximumSearch,
          trigger: trigger
        });
        this.triggerRegex = (0, _makeTypingTriggerRegex.default)({
          trigger: trigger,
          maximumSearch: maximumSearch,
          matchOnlyTrigger: !requireNonEmptySearchTerm
        });
      }
    }
  }, {
    key: "getResults",
    value: function getResults(search) {
      var _this$props4 = this.props,
          data = _this$props4.data,
          dataProp = _this$props4.dataProp,
          transformData = _this$props4.transformData;
      var regex = new RegExp(search.trim().replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
      var correctData = this.props[dataProp] || data || [];
      var transformedData = transformData(correctData);
      return transformedData.filter(function (_ref2) {
        var value = _ref2.value,
            searchText = _ref2.searchText,
            text = _ref2.text;
        var toSearch = searchText || text;
        return toSearch.match(regex) !== null || value.toString().match(regex) !== null;
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent(currentSearch) {
      var _this$props5 = this.props,
          addKeyCommandListener = _this$props5.addKeyCommandListener,
          data = _this$props5.data,
          removeKeyCommandListener = _this$props5.removeKeyCommandListener,
          onSelect = _this$props5.onSelect,
          portalId = _this$props5.portalId,
          rest = (0, _objectWithoutProperties2.default)(_this$props5, ["addKeyCommandListener", "data", "removeKeyCommandListener", "onSelect", "portalId"]);

      if (data === null) {
        return _react.default.createElement(LoadingSizer, null, _react.default.createElement(_UILoadingSpinner.default, null));
      }

      if (currentSearch === null) {
        return _react.default.createElement("div", null);
      }

      var results = this.getResults(currentSearch.search);
      return _react.default.createElement("div", {
        ref: "dropdown",
        className: "overlay-dropdown"
      }, _react.default.createElement(this.ResultsContainer, Object.assign({}, currentSearch, rest, {
        portalId: portalId,
        results: results,
        onSelect: onSelect,
        onCancel: this.cancel,
        forceClose: this.forceClose,
        toggleForcedOverlayFocus: this.handleToggleForcedOverlayFocus,
        addKeyCommandListener: addKeyCommandListener,
        removeKeyCommandListener: removeKeyCommandListener
      })));
    }
  }, {
    key: "renderTriggerAnchor",
    value: function renderTriggerAnchor(shouldBeOpen) {
      var placement = this.props.overlayPositioning.placement;

      if (!shouldBeOpen) {
        return null;
      }

      var coordinates = this.state.forceOverlayFocus ? this.savedCoordinates : this.getVisibleSelectionRectAtTrigger(this.saveCoordinates) || this.savedCoordinates;

      if (coordinates === null) {
        return null;
      }

      var _getOverlayAnchorPosi = (0, _getOverlayAnchorPosition.default)(placement, coordinates),
          top = _getOverlayAnchorPosi.top,
          left = _getOverlayAnchorPosi.left;

      return _react.default.createElement("div", {
        className: "trigger-anchor",
        style: {
          position: 'fixed',
          visibility: 'hidden',
          top: top,
          left: left
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          onOpen = _this$props6.onOpen,
          onClose = _this$props6.onClose,
          overlayPositioning = _this$props6.overlayPositioning;
      var currentSearch = this.getCurrentSearch();
      var shouldBeOpen = currentSearch !== null;
      var placement = overlayPositioning.placement;
      return _react.default.createElement(_UIPopover.default, {
        open: shouldBeOpen,
        content: this.renderContent(currentSearch),
        placement: placement,
        onOpenComplete: onOpen,
        onCloseComplete: onClose
      }, this.renderTriggerAnchor(shouldBeOpen));
    }
  }]);
  return Overlay;
}(_react.Component);

Overlay.propTypes = {
  addKeyCommandListener: _propTypes.default.func.isRequired,
  data: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_immutable.List), _propTypes.default.array]),
  dataProp: _propTypes.default.string,
  editorState: _propTypes.default.object.isRequired,
  maximumSearch: _propTypes.default.number.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func,
  onOpen: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  overlayPositioning: _propTypes.default.object.isRequired,
  portalId: _propTypes.default.number.isRequired,
  removeKeyCommandListener: _propTypes.default.func.isRequired,
  requireNonEmptySearchTerm: _propTypes.default.bool.isRequired,
  ResultsComponent: _propTypes.default.elementType,
  transformData: _propTypes.default.func,
  trigger: _propTypes.default.string.isRequired
};
Overlay.defaultProps = {
  maximumSearch: 10,
  requireNonEmptySearchTerm: true,
  transformData: _identity.default,
  overlayPositioning: {
    placement: 'bottom right'
  },
  portalId: _PortalIdParser.default.get()
};
var _default = Overlay;
exports.default = _default;
module.exports = exports.default;